export function PuzzleIcon(props) {
  return (
    <svg
      version="1.1"
      x="0px"
      y="0px"
      width="958.752px"
      height="958.752px"
      viewBox="0 0 958.752 958.752"
      fill="white"
      {...props}
    >
      <g>
        <g>
          <g>
            <path
              d="M449.253,958.752v-0.531V832.572c-16.291,7.475-34.135,11.438-52.273,11.438c-17.053,0-33.599-3.375-49.179-10.03
				c-15.033-6.423-28.497-15.601-40.015-27.279c-23.725-24.055-36.533-55.922-36.065-89.728
				c0.453-32.706,13.529-63.528,36.821-86.788c23.291-23.261,54.13-36.296,86.842-36.707c0.534-0.009,1.063-0.011,1.597-0.011
				c18.14,0,35.982,3.965,52.274,11.438l0.122-125.12H299.506c3.631-6.34,8.994-14.236,15.154-23.226
				c11.912-17.385,20.783-37.496,20.497-60.273c-0.646-51.367-42.547-93.327-93.914-94.038c-0.448-0.006-0.903-0.009-1.35-0.009
				c-52.62-0.004-95.271,42.652-95.271,95.271c0,22.269,8.737,41.944,20.445,58.973c5.693,8.28,11.58,16.957,15.213,23.302H40.411
				c-22.091,0-40,17.909-40,40v398.965c0,22.092,17.909,40,40,40L449.253,958.752L449.253,958.752z"
            />
            <path
              d="M832.692,508.965c7.474,16.291,11.438,34.135,11.438,52.273c0,33.463-13.029,64.922-36.688,88.582
				c-23.66,23.66-55.119,36.688-88.582,36.688c-0.583,0-1.177-0.004-1.767-0.012c-32.707-0.453-63.527-13.529-86.789-36.82
				c-23.26-23.291-36.296-54.131-36.707-86.838c-0.233-18.711,3.729-37.108,11.423-53.875h-95.644h-15h-15.141l0.018,150.16
				c-5.298-3.033-15.108-9.637-24.136-15.863c-16.723-11.537-36.252-19.793-58.14-19.793c-0.408,0-0.813,0.002-1.224,0.008
				c-51.367,0.646-93.326,42.548-94.038,93.914c-0.244,17.599,4.289,34.119,12.378,48.354c16.382,28.824,47.36,48.268,82.884,48.268
				c21.888,0,40.968-8.93,58.136-19.793c10.578-6.692,18.84-12.832,24.138-15.865v0.705v179.164h0.122h15h15h408.843
				c22.092,0,40-17.909,40-40V508.965H832.692z"
            />
            <path
              d="M918.34,0H479.375v183.766c0,0,16.088-13.928,21.23-17.577c16.507-13.723,37.721-21.979,60.863-21.979
				c53.066,0,95.999,43.386,95.264,96.622c-0.711,51.366-42.671,93.268-94.038,93.913c-0.408,0.005-0.818,0.008-1.227,0.008
				c-23.145,0-44.356-8.255-60.863-21.979c-5.145-3.648-21.229-17.576-21.229-17.576v183.768h30h149.87
				c-1.389,2.841-9.421,15.021-15.986,24.294c-11.921,16.836-19.943,36.914-19.665,59.205c0.646,51.365,42.548,93.324,93.914,94.037
				c0.448,0.006,0.902,0.01,1.352,0.01c24.636,0,47.087-9.352,63.999-24.694c19.21-17.431,31.271-42.595,31.271-70.578
				c0-21.832-8.228-41.308-19.7-58.017c-7.307-10.643-12.829-18.817-15.786-23.966c-0.059-0.1-0.113-0.192-0.171-0.292h177.133
				h2.735v-17.018V40C958.34,17.909,940.432,0,918.34,0z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
